var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-toggle-group",
    { attrs: { label: _vm.$ct("border"), value: _vm.toggleGroup } },
    [
      _c(
        "div",
        {
          staticClass: "styleColor styleTitle",
          attrs: { slot: "title" },
          slot: "title",
        },
        [_c("div", [_vm._v(" " + _vm._s(_vm.borderText) + " ")])]
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", md: "4" } },
            [
              _c("w-select", {
                attrs: {
                  fancy: "",
                  label: _vm.$ct("border-style"),
                  items: _vm.borderStyleItems,
                },
                model: {
                  value: _vm.toEditStyle.BorderStyle,
                  callback: function ($$v) {
                    _vm.$set(_vm.toEditStyle, "BorderStyle", $$v)
                  },
                  expression: "toEditStyle.BorderStyle",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "4" } },
            [
              _c("app-color-picker", {
                attrs: {
                  color: _vm.toEditStyle.BorderColor,
                  label: _vm.$ct("border-color"),
                  fancy: "",
                },
                model: {
                  value: _vm.toEditStyle.BorderColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.toEditStyle, "BorderColor", $$v)
                  },
                  expression: "toEditStyle.BorderColor",
                },
              }),
            ],
            1
          ),
          _c("w-col", { staticClass: "mt", attrs: { xs: "12", md: "12" } }, [
            _c("b", [_c("label", [_vm._v(_vm._s(_vm.$ct("borders")))])]),
          ]),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "12" } },
            [
              _c("w-checkbox", {
                attrs: { label: _vm.$ct("all-borders") },
                model: {
                  value: _vm.allBorders,
                  callback: function ($$v) {
                    _vm.allBorders = $$v
                  },
                  expression: "allBorders",
                },
              }),
            ],
            1
          ),
          _vm.allBorders
            ? _c(
                "div",
                { style: { width: "100%" } },
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "4" } },
                    [
                      _c("w-input-number", {
                        attrs: {
                          value: _vm.toEditStyle.BorderWidth,
                          min: 0,
                          fancy: "",
                          label: _vm.$ct("border-width"),
                        },
                        on: {
                          input: function ($event) {
                            return _vm.toEditStyle.setAllBorderWidths($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "w-col",
                [
                  _c(
                    "w-row",
                    { attrs: { "no-padding": "" } },
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "3" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              min: 0,
                              label: _vm.$ct("border-top-width"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.toEditStyle.BorderTopWidth,
                              callback: function ($$v) {
                                _vm.$set(_vm.toEditStyle, "BorderTopWidth", $$v)
                              },
                              expression: "toEditStyle.BorderTopWidth",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "3" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              min: 0,
                              label: _vm.$ct("border-right-width"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.toEditStyle.BorderRightWidth,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.toEditStyle,
                                  "BorderRightWidth",
                                  $$v
                                )
                              },
                              expression: "toEditStyle.BorderRightWidth",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "3" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              min: 0,
                              label: _vm.$ct("border-bottom-width"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.toEditStyle.BorderBottomWidth,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.toEditStyle,
                                  "BorderBottomWidth",
                                  $$v
                                )
                              },
                              expression: "toEditStyle.BorderBottomWidth",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "3" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              min: 0,
                              label: _vm.$ct("border-left-width"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.toEditStyle.BorderLeftWidth,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.toEditStyle,
                                  "BorderLeftWidth",
                                  $$v
                                )
                              },
                              expression: "toEditStyle.BorderLeftWidth",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
          _c("w-col", { staticClass: "mt", attrs: { xs: "12", md: "12" } }, [
            _c("b", [_c("label", [_vm._v(_vm._s(_vm.$ct("border-radius")))])]),
          ]),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "3" } },
            [
              _c("w-input-number", {
                attrs: {
                  min: 0,
                  label: _vm.$ct("border-radius-top-left"),
                  fancy: "",
                },
                model: {
                  value: _vm.toEditStyle.BorderRadiusTopLeft,
                  callback: function ($$v) {
                    _vm.$set(_vm.toEditStyle, "BorderRadiusTopLeft", $$v)
                  },
                  expression: "toEditStyle.BorderRadiusTopLeft",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "3" } },
            [
              _c("w-input-number", {
                attrs: {
                  min: 0,
                  label: _vm.$ct("border-radius-top-right"),
                  fancy: "",
                },
                model: {
                  value: _vm.toEditStyle.BorderRadiusTopRight,
                  callback: function ($$v) {
                    _vm.$set(_vm.toEditStyle, "BorderRadiusTopRight", $$v)
                  },
                  expression: "toEditStyle.BorderRadiusTopRight",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "3" } },
            [
              _c("w-input-number", {
                attrs: {
                  min: 0,
                  label: _vm.$ct("border-radius-bottom-left"),
                  fancy: "",
                },
                model: {
                  value: _vm.toEditStyle.BorderRadiusBottomLeft,
                  callback: function ($$v) {
                    _vm.$set(_vm.toEditStyle, "BorderRadiusBottomLeft", $$v)
                  },
                  expression: "toEditStyle.BorderRadiusBottomLeft",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "3" } },
            [
              _c("w-input-number", {
                attrs: {
                  min: 0,
                  label: _vm.$ct("border-radius-bottom-right"),
                  fancy: "",
                },
                model: {
                  value: _vm.toEditStyle.BorderRadiusBottomRight,
                  callback: function ($$v) {
                    _vm.$set(_vm.toEditStyle, "BorderRadiusBottomRight", $$v)
                  },
                  expression: "toEditStyle.BorderRadiusBottomRight",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }